import React, { useContext, useEffect, useState } from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';

function QIRAssignment({ controlId, controlName, label, value, businessUnitId, onChange, businessUnitDetails, disabled = false, readonly = false }) {
    const { t } = useTranslation();
    const [options, setOptions] = useState();

    useEffect(() => {
        setOptions(businessUnitDetails?.users ? businessUnitDetails.users.map((user) => ({ value: user, label: user })) : [])
    }, [businessUnitDetails?.users]);

    const [selectedOptions, setSelectedOptions] = useState(value && value.map((user) => ({ value: user, label: user })));

    const handleChange = (o) => {
        let e = {
            currentTarget: {
                name: controlName,
                value: o.map((o) => o.value)
            }
        };

        setSelectedOptions(o);

        onChange(e);
    };

    return (
        <Card className="mb-2">
            <Card.Header>{t('QIRDetail.Sections.Assignment')}</Card.Header>
            <Card.Body>
                <Form.Group as={Row} className="mb-1" controlId={controlId}>
                    <Form.Label column sm={2}>{label}</Form.Label>
                    <Col sm={10}>
                        <Select
                            size="sm"
                            isMulti={true}
                            options={options}
                            value={selectedOptions}
                            name={controlName}
                            onChange={handleChange}
                            isDisabled={disabled || !businessUnitId} />
                    </Col>
                </Form.Group>
            </Card.Body> 
        </Card>
    );
}

export default QIRAssignment;